import { useQuery } from '@tanstack/react-query';
import { crawlerClient } from 'clients/CrawlerClient/CrawlerClient';
import { isAxiosError } from 'helpers/clientHelpers';

export const useIsWerknlActive = () => {
  return useQuery(
    ['crawler-is-werknl-active'],
    async () => {
      try {
        const response = await crawlerClient.isWerknlActive();

        return { isActive: response.status === 200, status: response.status };
      } catch (e) {
        if (isAxiosError(e) && e.response?.status) {
          return { isActive: false, status: e.response.status };
        }

        throw e;
      }
    },
    { keepPreviousData: true, retry: 0, initialData: { isActive: false, status: 404 }, initialDataUpdatedAt: 0 },
  );
};
